define.alias("shared/modifiers/droppable", "calendar/modifiers/droppable");